/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./components/WizardMultiSearch'));
